import { type FC } from "react";
import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors } from "@snapchat/snap-design-system";
import { StatusCell } from "../../common/components/table/StatusCell";
import { AppVersionStatus } from "../models";
import { DecreaseText } from "../../common/components/text";

interface AppStatusCellProps {
    status?: string;
    content?: string;
}

// TODO: Replace with gql generated statuses once API is ready
const appStatusLabelMap: Record<string, { text: string; color: string }> = {
    [AppVersionStatus.ENABLED]: { text: "Enabled", color: Colors.Green.V150 },
    [AppVersionStatus.DISABLED]: { text: "Disabled", color: Colors.Red.V150 },
    [AppVersionStatus.UNKNOWN]: { text: "Unknown", color: Colors.Gray.V300 },
};

export const AppStatusCell: FC<AppStatusCellProps> = ({ status, content }) => (
    <CellWrapper>
        <StatusCell status={status ?? ""} statusMap={appStatusLabelMap} />
        {content && <DecreaseText className={textCss}>{content}</DecreaseText>}
    </CellWrapper>
);

const CellWrapper = styled.div({
    flexDirection: "column",
    display: "flex",
    gap: 10,
});

const textCss = css`
    color: ${Colors.Black.V50};
`;
